import React, { Component, useEffect } from "react";
import firebase from "../../firebase";
import "./bedallotment.css";
import FormPrompt from "../DailogBoxes/formprompt";
import Service from "../../Service/firebase";
import ErorrDialogBox from "../DailogBoxes/errordaologbox";
import AlertDialogBox from "../DailogBoxes/alertdailogbox";
import { useState } from "react";
import { Link } from "react-router-dom";

const BedAllotment = () => {
	const [selectedPatiendId, setSelectedPatiendId] = useState("");
	const [availableBedArray, setAvailableBedArray] = useState([]);
	const [selectedPatientName, setSelectedPatientName] = useState("");
	const [serachText, setSerachText] = useState("");
	const [limit, setLimit] = useState(10);
	const [bedNum, setBedNum] = useState("");
	const [totalNumOfPatient, setTotalNumOfPatient] = useState(null);
	const [noMoredataText, setNoMoredataText] = useState("");
	const [bedTypes, setBedTypes] = useState(["Type-1", "Type-2"]);
	const [isLoadMoredata, setIsLoadMoredata] = useState(false);
	const [isPromptLoading, setIsPromptLoading] = useState(false);
	const [isCloseBtnAppear, setIsCloseBtnAppear] = useState(true);
	const [isSearching, setIsSearching] = useState(false);
	const [isSearchDataShow, setIsSearchDataShow] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [openErrorDailog, setOpenErrorDailog] = useState(false);
	const [openFormDailog, setOpenFormDailog] = useState(false);
	const [patientlist, setPatientlist] = useState([]);
	const [openAlertDailog, setOpenAlertDailog] = useState(false);

	useEffect(() => {
		onSetTotalNumOfPatient();
		onFetchData(limit);
		// onSetBedTypes();
	}, []);
	// console.log(bedNum, ">>>");
	const firebaseData = async () => {
		const res = await Service.getAvailableBed();
		// console.log(res, "new log");
		if (res === "error") {
			console.log("Error in get person details data");
		} else {
			const test = res?.map((r) => r?.bedNum).sort((a, b) => a - b);
			setAvailableBedArray(test);
			// setIsLoading(false);
		}
		// console.log(res);
	};

	const showMore = () => {
		if (limit <= totalNumOfPatient) {
			const limits = limit + 10;

			setLimit(limits);
			onFetchData(limits);
		} else {
			setNoMoredataText("No More Patients");
		}
	};
	const onSetTotalNumOfPatient = () => {
		const db = firebase.firestore();
		db.collection("patients")
			.get()
			.then((snapshot) => {
				setTotalNumOfPatient(snapshot.docs.length);
			})
			.catch((e) => {
				console.log(e);
			});
	};
	// onSetBedTypes() {
	// 	const db = firebase.firestore();
	// 	db.collection("beds")
	// 		.doc("bedtypes")
	// 		.get()
	// 		.then((doc) => {
	// 			let bedTypes = doc.data().bedtypes;

	//
	// 				bedTypes: bedTypes,
	// 			});
	// 		})
	// 		.catch((e) => {
	// 			console.log(e);
	// 		});
	// }
	const onFetchData = async (limit) => {
		setIsLoadMoredata(true);
		firebaseData();
		const fetchedDataList = await Service.getData("patients", limit);

		if (fetchedDataList.length !== 0) {
			setPatientlist(fetchedDataList);
			setIsLoadMoredata(false);
			setIsLoading(false);
		} else {
			setIsLoading(false);
			setIsLoadMoredata(false);
		}
	};

	const handleSeach = async () => {
		if (serachText === "" || null) {
			onFetchData();
		} else {
			setIsSearching(true);
			setIsSearchDataShow(true);
			const searchText = serachText.toLowerCase().replace(/\s/g, "");
			const resultPatientlist = await Service.getSearchRes(
				"patients",
				searchText
			);
			if (resultPatientlist === "error") {
				setIsSearching(false);
				setOpenErrorDailog(true);
			} else {
				setPatientlist(resultPatientlist);
				setIsSearching(false);
			}
		}
	};
	// const handleSetCloseDailog = () => {
	// 	setSetAlertOpenDailog(false);
	// 	setOpenAlertDailog(false);
	// };
	const handleSubmit = async (event) => {
		setIsPromptLoading(true);
		setIsCloseBtnAppear(false);

		const data = new FormData(event.target);
		// console.log(data.get("bedType"), bedNum);
		const selectedBed = await Service.getSelectedBed(parseInt(bedNum));
		const bedid = selectedBed?.map((r) => r?.id);
		// const condition = selectedBed?.map((r) => r?.isAvailable);
		// console.log(bedid[0]);

		await Service.updateBed("availablebed", bedid[0], false);
		const sendData = {
			allotedbednum: bedNum,
			allotedbedtype: data.get("bedType"),
			caretaker: data.get("careTaker"),
			isadmitted: true,
			isDischarged: false,
			dischargedate: "",
			dischargetime: "",
			searchbyname: selectedPatientName.toLowerCase().replace(/\s/g, ""),
			allotedbeddatetime: firebase.firestore.Timestamp.fromDate(new Date()),
			isadmittedbefore: true,
			patientname: selectedPatientName,
			patientid: selectedPatiendId,
			usedbedId: bedid[0],
			timeStamp: firebase.firestore.Timestamp.fromDate(new Date()),
		};
		const res = await Service.addDataAndReturnId(
			sendData,
			"beds",
			"bedallotementid"
		);
		if (res === "error") {
			setIsPromptLoading(false);
			setOpenFormDailog(false);
			setIsCloseBtnAppear(true);
			setOpenErrorDailog(true);
		} else {
			// console.log("the id:", res);
			const docId = res;
			const sendData = {
				isBedAllotted: true,
				bedallotementid: docId,
			};
			const result = await Service.updateData(
				"patients",
				selectedPatiendId,
				sendData
			);

			if (result === "success") {
				setIsPromptLoading(false);
				setOpenFormDailog(false);
				setIsCloseBtnAppear(true);
				setOpenAlertDailog(true);

				// onFetchData()
			} else {
				setIsPromptLoading(false);
				setOpenFormDailog(false);
				setIsCloseBtnAppear(true);
				setOpenErrorDailog(true);
			}
		}
	};
	const closeFormDailog = () => {
		setOpenFormDailog(false);
	};
	const closeErrorDailog = () => {
		setOpenErrorDailog(false);
	};
	const closeAlertDailog = () => {
		setOpenAlertDailog(false);

		onFetchData();
	};

	let count = 0;
	return isLoading ? (
		<div className="bedallotmentpage">
			<i className="fas fa-spinner fa-pulse fa-2x"></i>
		</div>
	) : (
		<div className="bedallotmentpage">
			<div className="main_section ">
				<div className="topheader">
					<ul>
						<li>
							<Link to="/bedlist">
								<i
									className="fa fa-arrow-circle-o-right fa-2x"
									aria-hidden="true"
								></i>
							</Link>
						</li>
						<li>
							<h5>BedAllotment</h5>
						</li>
					</ul>
				</div>
				<AlertDialogBox
					openDailog={openAlertDailog}
					onSetOpenDailog={closeAlertDailog}
					title="Added"
					des="New Patient has been alloted sccessfully"
				></AlertDialogBox>
				<ErorrDialogBox
					openDailog={openErrorDailog}
					onSetOpenDailog={closeErrorDailog}
					title="Error"
					des="Someting went wrong. Try again"
				></ErorrDialogBox>
				<FormPrompt
					openDailog={openFormDailog}
					title="Allot New Patient"
					onSetOpenDailog={closeFormDailog}
					isCloseBtnAppear={isCloseBtnAppear}
				>
					{isPromptLoading ? (
						<i
							className="fas fa-spinner fa-pulse fa-2x"
							style={{ position: "relative", top: " 0%", left: "40%" }}
						></i>
					) : (
						<form onSubmit={handleSubmit}>
							<div className="form-row">
								<div className="col-md">
									<label htmlFor="validationDefault10">Care Taker</label>
									<input
										name="careTaker"
										className="custom-select"
										id="validationDefault10"
									></input>
								</div>
							</div>

							<div className="form-row">
								<div className="col-md-6 mb-3">
									<label htmlFor="validationDefault10">Bed Type</label>
									<select
										name="bedType"
										className="custom-select"
										id="validationDefault10"
										required
									>
										{bedTypes.map((option, index) => {
											return <option key={index}>{option}</option>;
										})}
									</select>
								</div>
								<div className="col-md-6 mb-3">
									<label htmlFor="validationDefault11">Bed Number</label>
									<select
										name="bedNum"
										className="custom-select"
										value={bedNum}
										onChange={(e) => setBedNum(e.target.value)}
										required
										placeholder="--select--"
									>
										<option> --select-- </option>
										{availableBedArray?.map((option, index) => {
											return <option key={index}>{option}</option>;
										})}
									</select>
								</div>
							</div>
							<div
								className="btnsection"
								style={{
									display: "flex",
									justifyContent: "flex-end",
								}}
							>
								<button
									className="btn btn-success bg-edit"
									type="submit"
									style={{
										borderRadius: "10px",
										padding: "5px 10px",
										fontSize: "14px",
									}}
									//  onClick={handleFormDailog}
								>
									Ok
								</button>
							</div>
						</form>
					)}
				</FormPrompt>
				<div className="top_section">
					<div className="wrap">
						<ul>
							<li>
								<div className="search">
									<input
										type="text"
										className="searchTerm"
										placeholder="Search patient by full name"
										onKeyDown={(e) => {
											if (e.key === "Enter") {
												handleSeach();
											}
										}}
										onChange={(e) => {
											setSerachText(e.target.value);
										}}
									/>

									<button
										onClick={handleSeach}
										type="submit"
										className="searchButton"
									>
										<i className="fa fa-search"></i>
									</button>
								</div>
							</li>
							<li style={{ fontSize: "14px" }}> #</li>
							<li tyle={{ fontSize: "14px" }}>{patientlist.length} </li>
						</ul>
					</div>
				</div>
				<table className="table table-striped">
					<thead className="thead tablehead">
						<tr>
							<th scope="col">#</th>
							<th scope="col">Profile</th>
							<th scope="col">Name</th>
							<th scope="col">Sex</th>
							<th scope="col">Age</th>
							<th scope="col">Blood Group</th>
							<th scope="col">Mobile</th>
							{/* <th scope="col">Email</th> */}
							<th scope="col">City</th>
							<th scope="col">Date</th>
							<th scope="col">Time</th>
							<th scope="col">Option</th>
						</tr>
					</thead>
					{isSearching ? (
						<i className="fas fa-spinner fa-pulse fa-2x "></i>
					) : patientlist.length === 0 ? (
						<tbody>
							<tr>
								<td>No Patients Found</td>
							</tr>
						</tbody>
					) : (
						<tbody className="tablebody">
							{patientlist &&
								patientlist.map((p) => {
									count++;
									let date = new Date(p.timeStamp.toDate());
									const createdTime = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
									const createdDate = `${date.getDate()}/${date.getMonth()}/${date.getFullYear()}`;
									return (
										<tr key={p.patientid}>
											<td className="align-middle">{count}</td>
											<td className="align-middle">
												{p.imgaeurl === "" ? (
													<div className="userbg">
														<i className="fa fa-user fa-2x"></i>
													</div>
												) : (
													<img className="image" alt="" srcSet={p.imgaeurl} />
												)}
											</td>
											<td className="align-middle">
												{p.firstname + " " + p.lastname}
											</td>
											<td className="align-middle">{p.sex}</td>
											<td className="align-middle">
												{p.age === "" ? "N/A" : p.age}
											</td>
											<td className="align-middle">
												{p.bloodgroup === "" ? "N/A" : p.bloodgroup}
											</td>
											<td className="align-middle">
												{" "}
												{p.phonenumber === "" ? "N/A" : p.phonenumber}
											</td>
											{/* <td className="align-middle">
                          {" "}
                          {p.email == "" ? "N/A" : p.email}
                        </td> */}
											<td className="align-middle">
												{p.city === "" ? "N/A" : p.city}
											</td>
											<td className="align-middle">
												{createdDate === "" ? "N/A" : createdDate}
											</td>
											<td className="align-middle">
												{createdTime === "" ? "N/A" : createdTime}
											</td>
											<td className="align-middle">
												{p.isBedAllotted ? (
													" Allotted"
												) : (
													<div>
														<button
															onClick={() => {
																setSelectedPatiendId(p.patientid);
																setSelectedPatientName(
																	p.firstname + " " + p.lastname
																);

																setOpenFormDailog(true);
															}}
															type="button"
															className="btn btn-success bg-edit"
														>
															+ Allot
														</button>
													</div>
												)}
											</td>
										</tr>
									);
								})}
						</tbody>
					)}
				</table>
				<div className="loadmoredatasection">
					{isLoadMoredata ? (
						<i className="fas fa-spinner fa-pulse fa-2x loadmoredataspinner"></i>
					) : (
						<div className="nomoredatatext">{noMoredataText}</div>
					)}
					{patientlist.length === 0 ? null : isSearchDataShow ? null : (
						<button
							type="button"
							className="btn btn-warning bg-add"
							onClick={showMore}
						>
							Show More
						</button>
					)}
				</div>
			</div>
		</div>
	);
};

export default BedAllotment;
